import React, { useState, useEffect } from "react";
import { Analytics } from '@vercel/analytics/react';
import "./App.css";

// Components
import Navbar from "./components/Navbar";
import Landing from "./components/Landing";
import EmailSubscription from "./components/EmailSubscription";
import About from "./components/About";
import Gameplay from "./components/Gameplay";
import Arena from "./components/Arena";
import Artwork from "./components/Artwork";
import FAQ from "./components/FAQ";
import EarlyAccessModal from "./components/EarlyAccessModal";

function App() {
  const [showModal, setShowModal] = useState(false);

  // Auto-trigger modal after 45 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 45000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <Navbar onEarlyAccessClick={() => setShowModal(true)} />

      <main>
        <Landing onEarlyAccessClick={() => setShowModal(true)} />
        <EmailSubscription />
        <About />
        <Gameplay />
        <Arena />
        <Artwork onEarlyAccessClick={() => setShowModal(true)} />
        <FAQ />
      </main>

      <EarlyAccessModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
      
      <Analytics />
    </div>
  );
}

export default App;
